
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 250 150"}, attrs),
              ...rest,
            },
            children.concat([_c('clipPath',{attrs:{"id":"d"}},[_c('circle',{attrs:{"r":"25"}})]),_c('path',{attrs:{"fill":"#e8112d","d":"M0 0h250v150H0z"}}),_c('g',{attrs:{"transform":"translate(125 75)"}},[_c('g',{attrs:{"id":"c","transform":"scale(.25)"}},[_c('g',{attrs:{"id":"b"}},[_c('path',{attrs:{"id":"a","d":"M-8.4 108C0 130-18 164 0 180c-6-24 14-50 8.4-72s-25.2-22-16.8 0z","fill":"#ffef00"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"rotate(90)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"rotate(180)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"rotate(270)"}})]),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(18)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(36)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(54)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(72)"}})]),_c('use',{attrs:{"xlink:href":"#c","transform":"rotate(9)"}}),_c('circle',{attrs:{"r":"27","fill":"#e8112d"}}),_c('circle',{attrs:{"cy":"-1.5","r":"22.5","fill":"#ffef00"}}),_c('g',{attrs:{"id":"e","fill":"#e8112d","clip-path":"url(#d)"}},[_c('path',{attrs:{"d":"M-23.055 18a37.755 37.755 0 1175.51 0h.305a36.26 36.26 0 10-72.52 0z"}}),_c('path',{attrs:{"d":"M-17.601 18A35.301 35.301 0 1153 18h.424a33.925 33.925 0 10-67.85 0z"}}),_c('path',{attrs:{"d":"M20.7-15.052a33.052 33.052 0 100 66.104l1.8-1.232a31.82 31.82 0 110-63.64z"}})]),_c('use',{attrs:{"xlink:href":"#e","transform":"scale(-1 1)"}})])])
          )
        }
      }
    